import { MaintenanceConfigurationResponse } from "../models/maintenance-configuration-response.model";

export function createDefaultConfiguration(accountId: number): MaintenanceConfigurationResponse {
  return {
    accountId,
    notificationLeadTimeDays: 30,
    autoApproveOemRequest: false,
    autoApproveDriverRequest: false,
    autoApproveWorkshopRequest: false,
    autoApproveComplianceRequest: false,
    autoApproveCanBusRequest: false,
    maxJobsPerDay: 4,
    maxHoursPerDay: 6,
    autoAssignTechnician: false,
    autoApproveWorkOrderRequest: false,
  };
}